// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2G6Fe","footer":"ChangeClinic_footer__1eRJc"};